import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import Toasted from 'vue-toasted'
import AuthLink from '@/components/AuthLink'
import AuthButton from '@/components/AuthButton'
import AuthBlock from '@/components/AuthBlock'

Vue.use(Toasted, {
  iconPack: 'fontawesome'
})

Vue.toasted.showSuccess = message => {
  Vue.toasted.success(message, {
    icon: 'fa-check',
    duration: '3000',
    position: 'bottom-right'
  })
}

Vue.toasted.showError = message => {
  Vue.toasted.error(message, {
    duration: '3000',
    position: 'bottom-right'
  })
}

Vue.config.productionTip = false

Vue.component('auth-link', AuthLink)
Vue.component('auth-button', AuthButton)
Vue.component('auth-block', AuthBlock)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
